import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-379aefce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Downloading Ditto", -1))
const _hoisted_2 = { class: "dt-instructions__instructions-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("article", {
  key: "1",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/download@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "1. Download"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, "Download the Ditto Connect app on your Android device."),
      /*#__PURE__*/_createElementVNode("a", {
        class: "dt-instructions__play-badge",
        href: "https://play.google.com/store/apps/details?id=com.airsquirrels.ditto_sender_android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        target: "_blank",
        rel: "noreferrer noopener"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "Get it on Google Play",
          src: "/images/google-play-badge.png"
        })
      ])
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("article", {
  key: "2",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/ditto@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "2. Enter"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, [
        /*#__PURE__*/_createTextVNode("Enter the Ditto room code in the app and select "),
        /*#__PURE__*/_createElementVNode("strong", null, "Connect"),
        /*#__PURE__*/_createTextVNode(".")
      ])
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("article", {
  key: "3",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/share@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "3. Share"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, [
        /*#__PURE__*/_createTextVNode("Tap the "),
        /*#__PURE__*/_createElementVNode("strong", null, "Share Screen"),
        /*#__PURE__*/_createTextVNode(" button in the Ditto Connect app, press "),
        /*#__PURE__*/_createElementVNode("strong", null, "Start Now"),
        /*#__PURE__*/_createTextVNode(" and your screen will wirelessly connect to the display.")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, {
        appear: "",
        name: "fade-up"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ], 64))
}